import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { sessionExtend } from '../../../utilities/partnerServices';

export const fetchExtendSession = createAsyncThunk(
    'sessionExtend', sessionExtend
)

const initialState = {
    value: [
    ]
}

const extendSessionSlice = createSlice({
    name: 'fundSpecificLookupSlice',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchExtendSession.pending, (state, action) => {
                // toast.warn("PreQualQuestions pending")
            })
            .addCase(fetchExtendSession.fulfilled, (state, action) => {
            })
            .addCase(fetchExtendSession.rejected, (state, action) => {
                // toast.error(action.error.message)
            })
    },
})


export default extendSessionSlice.reducer